export const ADMIN_COLLECTION = 'admin';
